export enum $findingCounts {
  auto = 'auto',
  manual = 'manual',
  total = 'total',
}
